import { Dispatch } from 'redux';
import ActionType from '../actionTypes/changeStyleActionType';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import GarmentsConverter from "../../converter/GarmentsConverter";

export const loadGarments = (selectedCategoryId: number, currentGarmentId: number) => async (
    dispatch: Dispatch
): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.LOAD_GARMENTS(selectedCategoryId, currentGarmentId);
    const actionTypes = ActionType.loadGarments;

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        (GarmentsRaw: any) => {
            return GarmentsConverter.convertAll(
                GarmentsRaw
            );
        }
    );
};

